export default {
  size: "medium",
  order: { location_id: "asc" },
  version: "v1.011",
  fields: [
    {
      id: "BULK_CHECKBOX",
      label: "",
      alwaysVisible: true,
      visible: true,
      unEditable: true,
      disableOrder: true,
      width: 60,
      system: true,
      isFrozen: true,
    },
    {
      id: "locationName",
      label: "Location Name",
      visible: true,
    },
    {
      id: "occupied",
      label: "Occupied Status",
      visible: true,
      unEditable: true,
    },
    {
      id: "dimensions",
      label: "Location Height",
      visible: true,
      unEditable: true,
    },
    {
      id: "sqFtOfSlot",
      label: "Square Footage",
      visible: true,
      unEditable: true,
      summable: true,
    },
    {
      id: "baseLocation",
      label: "Base Location",
      visible: true,
      unEditable: true,
      disableOrder: true,
    },
    {
      id: "locationType",
      label: "Location Type",
      visible: true,
      unEditable: true,
    },
    /*
    {
      id: "aisle",
      label: "Aisle (Row)",
      visible: true,
      unEditable: true,
    },
    {
      id: "rack",
      label: "Rack (Bay)",
      visible: true,
      unEditable: true,
    },
    {
      id: "shelf",
      label: "Shelf (Level)",
      visible: true,
      unEditable: true,
    },
    {
      id: "slot",
      label: "Slot (Bin)",
      visible: true,
      unEditable: true,
    },
    */
    {
      id: "locationId",
      label: "Location ID",
      visible: true,
      unEditable: true,
    },
  ],
};
